import Image from '../Image/Image';
import { motion } from 'framer-motion';
import { store } from '../../App';
import scroll from '../../utils/helpers/scroll';
import playAudio from '../../utils/helpers/playAudio';
import './Hero.scss';

import avatar from '../../assets/images/manish-yadav.png';
import arrowIcon from '../../assets/images/arrow.png';
import { useContext } from 'react';

export default function Hero() {
  const [state] = useContext(store);

  const description = {
    german: (
      <>
        <strong>Full-Stack-Entwickler</strong> mit über 10 Jahren Erfahrung in
        Fintech, Gaming, ECM, Experte für JavaScript, React, Node.js, PHP und
        sichere Zahlungsintegration.
      </>
    ),
    english: (
      <>
        <strong>Full Stack Developer</strong> with 10+ years’ experience in
        fintech, gaming, ECM, expert in JavaScript, React, Node.js, PHP, and
        secure payment integration.
      </>
    ),
  };

  return (
    <div
      className={`container-hero ${
        state.darkmode ? 'dark-bg-1' : 'light-bg-1'
      }`}
    >
      <div className="anchor" id="hero" />

      <motion.div
        className="container-avatar"
        initial={{ opacity: 0, y: 350 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ type: 'spring', duration: 0.6 }}
      >
        <img src={avatar} />
      </motion.div>

      <motion.h2
        className={state.darkmode ? 'white-opacity' : 'light-eyebrow'}
        initial={{ opacity: 0, y: 140 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          delay: 0.2,
          opacity: { duration: 0.2 },
          y: { duration: 0.55, type: 'spring' },
        }}
      >
        Manish Yadav
      </motion.h2>

      <motion.h1
        className={state.darkmode ? 'dark-heading' : 'light-heading'}
        initial={{ opacity: 0, y: 400 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          delay: 0.29,
          opacity: { duration: 0.2 },
          y: { duration: 0.6, type: 'spring' },
        }}
      >
        {state.language === 'english'
          ? 'Software-Entwickler'
          : 'Software Developer'}
      </motion.h1>

      <motion.h4
        className={state.darkmode ? 'white-opacity-max' : 'light-phrase'}
        initial={{ opacity: 0, y: 140 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          delay: 0.5,
          opacity: { duration: 0.15 },
          y: { duration: 0.55, type: 'spring' },
        }}
      >
        <motion.a
          className="manifest"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
        >
          <h3>
            {state.language === 'english'
              ? description['german']
              : description['english']}
          </h3>
        </motion.a>
        {/* {description[state.language as 'german' | 'english']} */}
      </motion.h4>

      <motion.button
        onClick={() => scroll('about-me')}
        onMouseDown={playAudio}
        onMouseUp={playAudio}
        initial={{ opacity: 0, y: 140 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{
          delay: 0.7,
          opacity: { duration: 0.15 },
          y: { duration: 0.4, type: 'spring' },
        }}
      >
        <h3>
          {state.language === 'english' ? 'Mehr erfahren' : 'Find out more'}
        </h3>
        <img src={arrowIcon} />
      </motion.button>
    </div>
  );
}
